import Page, { getStaticProps } from './page/[pageNo]';

export default Page;

export { getStaticProps };
